import get from 'lodash/fp/get';
import isEqual from 'lodash/fp/isEqual';
import pipe from 'lodash/fp/pipe';
import { useRouter } from 'next/router';

const getQueryMetaSearchParam = pipe(get(`metasearch`), isEqual(`true`));

const useMetaSearchParam = () => {
  const { query } = useRouter();
  return getQueryMetaSearchParam(query);
};

export default useMetaSearchParam;
